import { environment } from '../../environments/environment';

export const serverUrl = environment.serverUrl;
export const apiVersion = environment.apiVersion;

export const API_URLS = {
  API_URL: `${serverUrl}${apiVersion}`,
  APPLICATION_CONFIGURATION: `${serverUrl}${apiVersion}/ApplicationConfiguration`,
  CLIENT_SETTINGS: `${serverUrl}${apiVersion}/ApplicationConfiguration/client-settings`,
  AUTHROUTE: '/auth',
  AUTHROUTECREATE: '/signup'
};

export const END_POINTS = {
  GET_ALL: '/GetList',
  GET_ONE: '/Get',
  GET_NEW: '/GetNew',
  CREATE: '/Create',
  UPDATE: '/Update',
  DELETE: '/Delete',
  SEARCH: '/Search',
  enums: '/enums',
  // School Invitation Flow Endpoints
  SETINVITATION: '/school/invitation',
  GETINVITATION: '/school/invitation',
  GETPROGRAMS: '/lookup/school-programs',
  GETPROGRAMSLIST: 'lookup/school-programs-list',
  GET_SCHOOL_PROGRAMS: (schoolId: number) =>
    `/admin/schools/${encodeURIComponent(schoolId)}/programs`,
  CREATE_SCHOOL_PROGRAM: (schoolId: number) =>
    `/admin/schools/${encodeURIComponent(schoolId)}/programs`,
  UPDATE_SCHOOL_PROGRAM: (schoolId: number, programId: number) =>
    `/admin/schools/${encodeURIComponent(schoolId)}/programs/${encodeURIComponent(String(programId))}`,
  GET_SCHOOL_STAFF: (schoolId : number) =>
    `/admin/schools/${encodeURIComponent(schoolId)}/users`,
  ADD_SCHOOL_STAFF: (schoolId : number) =>
    `/admin/schools/${encodeURIComponent(schoolId)}/users`,  
  UPDATE_SCHOOL_STAFF: (schoolId : number, ignyteUserId  : number) =>
    `/admin/schools/${encodeURIComponent(schoolId)}/users/${encodeURIComponent(ignyteUserId )}`,
  GETSCHOOLS: '/lookup/schools',
  GET_ADMIN_SCHOOLS: '/admin/schools',
  GET_APPLICATIONS: '/school/application',
  GET_OPERATIONSAPPLICATIONS: '/school/application',
  GETSTATES: (pageSize: number, pageNumber: number) =>
    `/lookup/states?pageNumber=${pageNumber}&pageSize=${pageSize}`,
  GET_ALL_APPLICATION_FOR_BORROWER: '/student/application',
  AUTHSCHOOLADMINROUTE: '/students/student-management',
  AUTHOPERATIONSADMINROUTE: '/students/student-management',
  AUTHAPPLICANTSELECTIONROUTE: '/student/applications-selection',
  AUTHSTUDENTROUTE: (code: string) =>
    `/student/application/${encodeURIComponent(code)}`,
  RESENDINVITATION: (code: string) =>
    `/school/invitation/${encodeURIComponent(code)}/reminder`,
  // Student Invitation Flow Endpoints
  GETSTUDENTCONTACT: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/contact`,
  SETSTUDENTCONTACT: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/contact`,
  GETCURRENTRESIDENCE: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/current-residence`,
  SETCURRENTRESIDENCE: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/current-residence`,

  GETSCHOOLPROGRAM: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/school-program`,
  SETSCHOOLPROGRAM: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/school-program`,

  GETLIVINGEXPENSES: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/living-expenses`,
  SETLIVINGEXPENSES: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/living-expenses`,

  GETSTUDENTCONSENT: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/consent`,
  SETSTUDENTCONSENT: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/consent`,

  GETEMPLOYMENTINCOME: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/employment-income`,
  SETEMPLOYMENTINCOME: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/employment-income`,

  GETOFFER: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/offer`,

  SETOFFER: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/offer`,

  SETAPPLICANTSUBMIT: (code: string) =>
    `/student/invitation/${encodeURIComponent(code)}/application-review`,

  //Applicant Flow
  GETAPPLICANT: (appId: string) => `/application/${encodeURIComponent(appId)}`,

  SETAPPLICANTEMPANDINCOME: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/employment-income`,

  SETAPPLICANTADDRESS: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/address`,

  SETAPPLICANTBANKACCOUNT: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/bank-account`,

  SETAPPLICANTCONTACT: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/contact-details`,

  SETAPPLICANTHOUSING: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/housing-situation`,

  SETAPPLICANTREFERENCES: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/references`,

  SETAPPLICANTSCHOOL: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/school-program`,

  GETAPPLICANTREQUIREDCOUNTS: (appId: string, borrowerId?: number) =>
    `/application/${encodeURIComponent(appId)}/required-counts${
      borrowerId !== undefined && borrowerId !== null
        ? `?borrowerId=${encodeURIComponent(borrowerId)}`
        : ''
    }`,

  APPLICATIONSUBMIT: (appId: string) =>
    `/application/${encodeURIComponent(appId)}/submit`,
  INVITE_CO_BORROWER: (code: string) =>
    `/application/${encodeURIComponent(code)}/co-borrower`,
  REMIND_CO_BORROWER: (code: string, invitationCode: string | number) =>
    `/application/${encodeURIComponent(code)}/co-borrower/reminder/${encodeURIComponent(String(invitationCode))}`,
  REMOVE_CO_BORROWER: (code: string, params: { borrowerId?: string | number; invitationCode?: string }) => {
    let url = `/application/${encodeURIComponent(code)}/co-borrower`;
    if (params.invitationCode) {
      url += `?invitationCode=${encodeURIComponent(params.invitationCode)}`;
    } else if (params.borrowerId) {
      url += `?borrowerId=${encodeURIComponent(String(params.borrowerId))}`;
    }
    return url;
  },

  // Lookup Endpoints
  GETAPPLICATIONDECISIONS: '/lookup/application-decisions',

  // Operations Endpoints
  SETAPPLICATIONSTATUS: (appId: string, status: string) =>
    `/operations/application/${encodeURIComponent(
      appId
    )}/status/${encodeURIComponent(status)}`,
  UPDATE_REFUND_REVIEW_ADMIN: (refundRequestId: string) =>
    `/operations/application/review-refund/${encodeURIComponent(refundRequestId)}`,

  GET_SCHOOL_USERS: (code: string) =>
    `/operations/application/${encodeURIComponent(code)}/schoolUsers`,

  GETOPERATIONSINVITATIONS: `/operations/invitation`,
  OPERATIONS_RESEND_INVITATION: (code: string) =>
    `/operations/${encodeURIComponent(code)}/reminder`,
  OPERATIONS_INVITATION_LINK: (code: string) =>
    `/operations/${encodeURIComponent(code)}/invitationLink`,

  GETOPERATIONSAPPLICATIONS: '/operations/application',
  GET_ASSIGNED_TO: '/operations/assignedto',
  SET_ASSIGNED_TO: (code: string, userId: string | null) =>
    `/operations/application/${encodeURIComponent(code)}${userId ? `?assignedTo=${encodeURIComponent(userId)}` : '?assignedTo='}`,

  REMIND_CONFIRM_ENROLLMENT: (code: string) =>
    `/operations/application/${encodeURIComponent(code)}/reminderConfirmEnrollmentRequest`,

  /** GET /api/v1/school/application/refund-list */
  GET_REFUND_LIST: '/school/application/refund-list',
  GET_OPERATIONS_REFUND_LIST_ADMIN: '/operations/application/refund-list',

  CREATE_LOAN: (code: string) =>
    `/operations/application/${encodeURIComponent(code)}/create-loan`,

  FUND_LOAN: (code: string) =>
    `/operations/application/${encodeURIComponent(code)}/fund-loan`,

  GETBORROWERSSN: (borrowerId: number) =>
    `/operations/application/borrower/${encodeURIComponent(borrowerId)}/ssn`,

  GETBORROWER_ACCOUNTNUMBER: (borrowerId: number) =>
    `/operations/application/borrower/${encodeURIComponent(borrowerId)}/view_account_number`,

  GETBORROWER_ROUTINGNUMBER: (borrowerId: number) =>
    `/operations/application/borrower/${encodeURIComponent(borrowerId)}/view_routing_number`,

  GET_APPLICATION_OPERATIONS: (code: string, borrowerId: number) =>
    `/application/${encodeURIComponent(code)}/borrower/${encodeURIComponent(
      borrowerId
    )}/operations`,

  SUBMIT_CO_BORROWER: (code: string, borrowerId: number) =>
    `/application/${encodeURIComponent(code)}/borrower/${encodeURIComponent(
      borrowerId
    )}/submit`,

  SETAPPLICANTCONSENT: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/consent`,

  // Agreement Endpoints
  GETAGREEMENTS: (borrowerId: string) =>
    `/applications/borrower/${encodeURIComponent(borrowerId)}/agreements`,
  GETNEWAGREEMENT: (borrowerId: string) =>
    `/applications/borrower/${encodeURIComponent(borrowerId)}/agreements/new`,
  CREATEAGREEMENT: (borrowerId: string) =>
    `/applications/borrower/${encodeURIComponent(borrowerId)}/agreements`,
  VIEWAGREEMENT: (borrowerId: string, agreementId: number) =>
    `/applications/borrower/${encodeURIComponent(
      borrowerId
    )}/agreements/${encodeURIComponent(agreementId)}`,
  REMINDAGREEMENT: (borrowerId: string, agreementId: number) =>
    `/applications/borrower/${encodeURIComponent(
      borrowerId
    )}/agreements/${encodeURIComponent(agreementId)}/remind`,
  CANCELAGREEMENT: (borrowerId: string, agreementId: number) =>
    `/applications/borrower/${encodeURIComponent(
      borrowerId
    )}/agreements/${encodeURIComponent(agreementId)}/cancel`,
  GETTERMSAPR: (borrowerId: string) =>
    `/applications/borrower/${encodeURIComponent(
      borrowerId
    )}/agreements/terms-apr`,

  //documents
  ADD_DOCUMENT: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/document`,

  REQUEST_DOCUMENT: (borrowerId: number) =>
    `/application/borrower/${encodeURIComponent(borrowerId)}/document/request`,

  UPLOAD_DOCUMENT: (borrowerId: number, documentId: number) =>
    `/application/borrower/${encodeURIComponent(
      borrowerId
    )}/document/${encodeURIComponent(documentId)}/upload`,

  REPLACE_DOCUMENT: (borrowerId: number, documentId: number) =>
    `/application/borrower/${encodeURIComponent(
      borrowerId
    )}/document/${encodeURIComponent(documentId)}/replace`,

  DELETE_DOCUMENT: (borrowerId: number, documentId: number) =>
    `/application/borrower/${encodeURIComponent(
      borrowerId
    )}/document/${encodeURIComponent(documentId)}`,

  EDIT_DOCUMENT: (borrowerId: number, documentId: number) =>
    `/application/borrower/${encodeURIComponent(
      borrowerId
    )}/document/${encodeURIComponent(documentId)}/edit`,

  VIEW_DOCUMENT: (borrowerId: number, documentId: number, schoolCode?: string) =>
    `/applications/borrower/${encodeURIComponent(
      borrowerId
    )}/agreements/${encodeURIComponent(documentId)}/view${schoolCode ? `?s=${encodeURIComponent(schoolCode)}` : ''}`,  

  OTPVALIDATION: (password: string) =>
    `/otpValidation?password=${encodeURIComponent(password)}`,

  OTPRESEND: '/otpValidation/resend',

  OPTRETURNURL: (code: string) => `/offer-details/${code}`,

  AUTHENTICATE: `/auth/authenticate`,
  SIGNOUT: `/auth/signout`,
  FORGOTPASSWORD: `/auth/forgotpassword`,
  RESETPASSWORD: `/auth/resetpassword`,
  REGISTERAPPLICANT: `/auth/RegisterApplicant`,
  REGISTERCOBORROWER: `/auth/RegisterCoBorrower`,
  REGISTEREDUSER: `/auth/IsRegisteredUser`,
  VALIDATERESETPASSWORDTOKEN: '/auth/ValidateResetPasswordToken',

  // Notes Endpoint
  GETNOTES: (loanApplicationId: number) =>
    `/application/${encodeURIComponent(loanApplicationId)}/notes`,
  SETNOTES: (loanApplicationId: number) =>
    `/application/${encodeURIComponent(loanApplicationId)}/notes`,
  UPDATENOTES: (loanApplicationId: number, noteId: number) =>
    `/application/${encodeURIComponent(loanApplicationId)}/notes/${encodeURIComponent(
      noteId
    )}`,
  REMOVENOTES: (loanApplicationId: number, noteId: number) =>
    `/application/${encodeURIComponent(loanApplicationId)}/notes/${encodeURIComponent(
      noteId
    )}`,
  
  // School Notes Endpoints
  GET_SCHOOL_NOTES: (loanApplicationId: number) =>
    `/school/application/${encodeURIComponent(loanApplicationId)}/notes`,
  SET_SCHOOL_NOTES: (loanApplicationId: number) =>
    `/school/application/${encodeURIComponent(loanApplicationId)}/notes`,

  DISTRIBUTION_SCHEDULE: '/distribution-schedule',
  OPERATIONS_DISTRIBUTION_SCHEDULE: '/operations/distribution-schedule',
  SCHOOL_DISTRIBUTION_SCHEDULE: '/school/distribution-schedule',
  OPERATIONS_DISTRIBUTION_SCHEDULE_ANALYTICS: '/operations/distribution-schedule/analytics',
  SCHOOL_DISTRIBUTION_SCHEDULE_ANALYTICS: '/school/distribution-schedule/analytics',

  //School-details page
  GET_SCHOOL_APPLICATION_DETAILS: (applicationId: string) =>
    `/school/application/${encodeURIComponent(applicationId)}`,
  CONFIRM_ENROLLMENT: (applicationId: string) =>
    `/school/application/${encodeURIComponent(applicationId)}/confirm-enrollment`,
  REFUND_REQUEST: (applicationId: string) =>
    `/school/application/${encodeURIComponent(applicationId)}/refund-request`,
  GET_REFUND_REVIEW: (applicationCode: string, refundRequestId: string) =>
    `/school/application/${encodeURIComponent(applicationCode)}/review-refund/${encodeURIComponent(refundRequestId)}`,
  UPDATE_REFUND_REVIEW: (refundRequestId: string) =>
    `/school/application/review-refund/${encodeURIComponent(refundRequestId)}`,

  GET_OPERATIONS_TASKS: '/operations/tasks',
  SET_TASK_STATUS: (taskId: string, status: number) =>
    `/operations/tasks/${encodeURIComponent(taskId)}/status/${encodeURIComponent(status)}`,
  /** PUT /api/v1/operations/tasks/{taskId} — update priority, due date, assigned user */
  UPDATE_TASK: (taskId: number | string) =>
    `/operations/tasks/${encodeURIComponent(taskId)}`,
  MARK_TASK_COMPLETE: (taskId: number | string) =>
    `/operations/tasks/${encodeURIComponent(taskId)}/complete`,
  REOPEN_TASK: (taskId: number | string) =>
    `/operations/tasks/${encodeURIComponent(taskId)}/reopen`,
  DELETE_TASK: (taskId: number | string) =>
    `/operations/tasks/${encodeURIComponent(taskId)}`,

  SELF_REGISTER: '/public/invite',
  VALIDATE_SCHOOL_TICKER: (schoolTicker: string) =>
    `/public/schoolticker/${encodeURIComponent(schoolTicker)}`,

  // Feature flags
  FEATURE_FLAGS: '/FeatureFlags',

  EDIT_SSN_ADMIN: (borrowerId: number, code: string) =>
    `/operations/application/borrower/${encodeURIComponent(borrowerId)}/${encodeURIComponent(code)}/ssn`,
};
